<template>
  <div>
    <PageAllow controller="Payment" action="getPaySettings" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{ $t("Payment.hfPay.title") }}
          <v-spacer></v-spacer>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <ValidationObserver ref="observer">
            <v-container>
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Payment.hfPay.application") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  {{ $t("Payment.hfPay.application_title") }}
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.hfPay.hfpay_mer_cust_id") + $t("Global.colon")
                  }}
                  <span class="red--text" v-if="settings.hfpay_enable">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.hfPay.hfpay_mer_cust_id')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="settings.hfpay_mer_cust_id"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'hfpay_mer_cust_id')
                          .concat(errors)
                      "
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- zheng shu -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Payment.hfPay.hfpay_cert_url") + $t("Global.colon") }}
                  <span class="red--text" v-if="settings.hfpay_enable">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.hfPay.hfpay_cert_url')"
                    rules="required"
                  >
                    <v-file-input
                      v-model="File"
                      show-size
                      :label="$t('Payment.hfPay.import')"
                      accept=".pfx"
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'hfpay_cert_url')
                          .concat(errors)
                      "
                    ></v-file-input>
                  </ValidationProvider>
                </v-col>
              </v-row>

              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.hfPay.hfpay_sign_check") + $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-text-field v-model="settings.hfpay_sign_check" single-line>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.hfPay.hfpay_in_acct_id") + $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-text-field v-model="settings.hfpay_in_acct_id" single-line>
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.hfPay.wechat_mini_app_id") + $t("Global.colon")
                  }}
                  <span class="red--text" v-if="settings.hfpay_enable">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.hfPay.wechat_mini_app_id')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="settings.wechat_mini_app_id"
                      single-line
                      disabled
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'wechat_mini_app_id')
                          .concat(errors)
                      "
                    >
                    </v-text-field>
                    <a @click="$router.push('/settings/mini-develop-program')">
                      {{ $t("Payment.hfPay.mini_develop_program") }}
                    </a>
                  </ValidationProvider>
                </v-col>
              </v-row>

              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Payment.hfPay.hfpay_enable") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group row v-model="settings.hfpay_enable">
                    <v-radio :label="$t('Payment.off')" key="0" value="0" />
                    <v-radio :label="$t('Payment.on')" key="1" value="1" />
                  </v-radio-group>
                </v-col>
              </v-row>

              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.hfPay.hfpay_cash_fee_enable") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  {{
                    settings.hfpay_cash_fee_enable == 1
                      ? $t("Payment.on")
                      : $t("Payment.off")
                  }}
                </v-col>
              </v-row>
              <v-row align="center" class="mt-0">
                <v-col cols="3" class="font-weight-bold text-right"> </v-col>
                <v-col cols="9" md="7">
                  <a
                    @click="
                      $router.push(
                        '/settings/sub-account-settings/sub-account-setting-port/sub-account-hf-pay-setting'
                      )
                    "
                  >
                    {{ $t("Payment.hfPay.hfpay_cash_fee_enable_account") }}
                  </a>
                </v-col>
              </v-row>
            </v-container>
          </ValidationObserver>
        </v-card-text>
      </v-card>
      <v-card class="page-opts">
        <v-card-title>
          <v-row dense>
            <v-col cols="12">
              <v-btn
                color="success"
                block
                @click="
                  settings.hfpay_cash_fee_enable ? (alertDialog = true) : save()
                "
              >
                <v-icon small class="pe-1">fa-save</v-icon>
                {{ $t("Payment.save") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-sheet>

    <DialogAlert
      v-model="alertDialog"
      :message="$t('Payment.change_wechat_pay', [$t('Payment.hfpay')])"
      useConfirm
      @confirm="save()"
    />
  </div>
</template>

<script>
import Payment from "@/api/payment";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import DialogAlert from "@/components/plugins/DialogAlert";
import { mapState } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  data: () => ({
    settings: {},
    serverErrors: [],
    File: null,
    alertDialog: false,
  }),
  components: {
    PageAllow,
    Breadcrumbs,
    DialogAlert,
    ValidationObserver,
    ValidationProvider,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.fundManagement"),
        disabled: false,
        href: "/receipts",
      },
      {
        text: i18n.t("Nav.payment"),
        disabled: true,
        href: "/payment",
      },
    ],
    ...mapState(["loading"]),
  },

  mounted() {
    this.getAlipayFromAPI();
  },

  methods: {
    getAlipayFromAPI() {
      Payment.fetch({
        keys: [
          "hfpay_mer_cust_id",
          "hfpay_sign_check",
          "hfpay_cert_url",
          "wechat_mini_app_id",
          "hfpay_enable",
          "hfpay_cash_fee_enable",
          "hfpay_in_acct_id",
        ],
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.settings = response.data.settings;
            if (
              this.settings.hfpay_enable == null ||
              typeof this.settings.hfpay_enable == "undefined" ||
              this.settings.hfpay_enable == undefined
            ) {
              this.settings.hfpay_enable = "0";
            }
          }
        }.bind(this)
      );
    },

    save() {
      delete this.settings.hfpay_cash_fee_enable;
      if (!this.settings.hfpay_enable) {
        if (File) {
          Payment.hfFileUpload(this.File);
        }
        Payment.hfPaySave(this.settings).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$router.push("/payment");
            }
          }.bind(this)
        );
      } else {
        this.$refs.observer.validate().then(
          function (result) {
            if (result) {
              Payment.hfFileUpload(this.File);

              Payment.hfPaySave(this.settings).then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.$router.push("/payment");
                  }
                }.bind(this)
              );
            }
          }.bind(this)
        );
      }
    },
  },
};
</script>

<style>
</style>